import { StyleSheet, Dimensions } from 'react-native';
import { ToastPosition, ToastType } from './DbToast.types';

const { width: SCREEN_WIDTH } = Dimensions.get('window');

/** 默认样式常量 */
export const TOAST_CONSTANTS = {
    defaultDuration: 2000,
    loadingDuration: 0, // loading 不自动关闭
    maxWidth: SCREEN_WIDTH * 0.8,
    minWidth: 100,
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
    iconSize: 24,
    fontSize: 14,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    textColor: '#FFFFFF',
    maskColor: 'transparent',
};

/** Toast 类型对应的颜色 */
export const TOAST_TYPE_COLORS: Record<ToastType, string> = {
    success: '#52C41A',
    error: '#FF4D4F',
    warning: '#FAAD14',
    info: '#1890FF',
    loading: '#FFFFFF',
    custom: '#FFFFFF',
};

/** Toast 类型对应的图标 */
export const TOAST_TYPE_ICONS: Record<ToastType, { name: string; family: string }> = {
    success: { name: 'checkmark-circle', family: 'Ionicons' },
    error: { name: 'close-circle', family: 'Ionicons' },
    warning: { name: 'warning', family: 'Ionicons' },
    info: { name: 'information-circle', family: 'Ionicons' },
    loading: { name: 'loading', family: 'custom' }, // 使用自定义 loading 动画
    custom: { name: '', family: '' },
};

/** 获取位置样式 */
export const getPositionStyle = (position: ToastPosition) => {
    switch (position) {
        case 'top':
            return { justifyContent: 'flex-start' as const, paddingTop: 100 };
        case 'bottom':
            return { justifyContent: 'flex-end' as const, paddingBottom: 100 };
        case 'center':
        default:
            return { justifyContent: 'center' as const };
    }
};

/** 基础样式 */
export const styles = StyleSheet.create({
    // 遮罩层
    overlay: {
        ...StyleSheet.absoluteFillObject,
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
    },
    
    // Toast 容器
    container: {
        backgroundColor: TOAST_CONSTANTS.backgroundColor,
        borderRadius: TOAST_CONSTANTS.borderRadius,
        paddingHorizontal: TOAST_CONSTANTS.paddingHorizontal,
        paddingVertical: TOAST_CONSTANTS.paddingVertical,
        maxWidth: TOAST_CONSTANTS.maxWidth,
        minWidth: TOAST_CONSTANTS.minWidth,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    },
    
    // 水平布局（图标在左）
    containerRow: {
        flexDirection: 'row',
    },
    
    // 图标容器
    iconContainer: {
        marginBottom: 8,
    },
    
    // 水平布局时的图标
    iconContainerRow: {
        marginBottom: 0,
        marginRight: 8,
    },
    
    // 消息文字
    message: {
        fontSize: TOAST_CONSTANTS.fontSize,
        color: TOAST_CONSTANTS.textColor,
        textAlign: 'center',
        lineHeight: 20,
    },
    
    // Loading 动画容器
    loadingContainer: {
        width: 24,
        height: 24,
        justifyContent: 'center',
        alignItems: 'center',
    },
    
    // Loading 旋转动画
    loadingSpinner: {
        width: 24,
        height: 24,
        borderWidth: 2,
        borderColor: 'rgba(255, 255, 255, 0.3)',
        borderTopColor: '#FFFFFF',
        borderRadius: 12,
    },
});
